import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Menu.css";
import "./MenuButton.css";
import * as React from "react";
import { MenuButton } from "./MenuButton";
import * as Resources from '../../Resources.Widgets';
var MoreButton = /** @class */ (function (_super) {
    tslib_1.__extends(MoreButton, _super);
    function MoreButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuButton = React.createRef();
        return _this;
    }
    MoreButton.prototype.render = function () {
        return (React.createElement(MenuButton, tslib_1.__assign({ ariaLabel: Resources.MoreActions, hideDropdownIcon: true, iconProps: { iconName: "MoreVertical" }, ref: this.menuButton, subtle: true }, this.props)));
    };
    MoreButton.prototype.focus = function () {
        if (this.menuButton.current) {
            this.menuButton.current.focus();
        }
    };
    return MoreButton;
}(React.Component));
export { MoreButton };
